import { Component, OnInit } from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import { Location } from '@angular/common';

@Component({
  selector: 'app-admissions',
  templateUrl: './admissions.component.html',
  styleUrls: ['./admissions.component.scss']
})
export class AdmissionsComponent implements OnInit {
    currentPath: string;

    stats = [
        {
            icon: 'fa fa-user',
            number: '11000+',
            text: 'Students On Campus',
            bgColor: 'bg-blue-500',
        },
        {
            icon: 'fa fa-book',
            number: '200+',
            text: 'Program/Plans Offered',
            bgColor: 'bg-teal-500',
        },
        {
            icon: 'fa fa-briefcase',
            number: '100+ MNC\'s',
            text: '& Corporates Visited',
            bgColor: 'bg-red-500',
        },
        {
            icon: 'fa fa-users',
            number: 'Upto 100%',
            text: 'Placement Assistance',
            bgColor: 'bg-yellow-500',
        },
    ];
/*    videos = [
        'https://youtu.be/RSa3v7KV2h4?si=ptiIHvt_ca5UvnaZ',
        'https://youtu.be/o2XShZHciAo?si=R4tZ9PMotrRhSDVJ',
        'https://youtu.be/plHHHDnscCA?si=cug6UsVHvRbcLGFl',
    ];*/
    facilities = {
        academic: [
            { title: 'E-learning rooms (Swayam/MOOCs)', image: 'assets/img/schools/7.jpg', description: 'The E-Learning Rooms have been developed to support students in their studies.' },
            { title: 'Recording studios (Multimedia development)', image: 'assets/img/schools/9.jpg', description: 'A hub for collaboration and experimentation in multimedia.' },
            { title: 'Moot Court', image: 'assets/img/schools/8.jpg', description: 'A simulated court experience for law students.' },
            { title: 'Students Activities Center', image: 'assets/img/schools/1.jpg', description: 'More than 20 clubs under Cultural, Sports, and Technical Societies.' }
        ],
        campus: [
            { title: 'Sports Complex', image: 'assets/img/schools/2.jpg', description: 'State-of-the-art sports facilities including indoor and outdoor sports.' },
            { title: 'Library', image: 'assets/img/schools/3.jpg', description: 'A vast collection of books, journals, and digital resources.' },
            { title: 'Hostel Facilities', image: 'assets/img/schools/4.jpg', description: 'Safe and comfortable hostel facilities for students.' },
            { title: 'Cafeteria', image: 'assets/img/schools/5.jpg', description: 'Multi-cuisine food court with healthy meal options.' }
        ]
    };
    recruiters = [
        { name: "Adani Wilmar", logo: "assets/img/companies/adani_wilmar.png" },
        { name: "Amar Ujala", logo: "assets/img/companies/amarujala.png" },
        { name: "Amazon", logo: "assets/img/companies/Amazon.png" },
        { name: "CMC", logo: "assets/img/companies/cmc-logo_0.png" },
        { name: "Dish TV", logo: "assets/img/companies/Dish_TV_2.png" },
        { name: "Future Group", logo: "assets/img/companies/FutureGroup.png" },
        { name: "HCL", logo: "assets/img/companies/hcl.png" },
        { name: "ICICI", logo: "assets/img/companies/icici_securities.png" },
        { name: "Sleepwell", logo: "assets/img/companies/sleepwell.png" },
        { name: "SYNTEL", logo: "assets/img/companies/syntel2.png" },
      /*  {
            name: "Tech Mahindra",
            logo: "assets/img/companies/Tech_Mahindra_New_Logo1.png",
        },
        { name: "Vodafone", logo: "assets/img/companies/Vodafone_logo.png" },
        { name: "Zee TV", logo: "assets/img/companies/Zee_TV_2011.png" },
        { name: "Genpact", logo: "assets/img/companies/zenpact.png" },
        { name: "Reliance", logo: "assets/img/companies/amarujala.png" },*/
    ];

    students = [
        {
            title: 'Graduate Students',
            image: 'assets/img/schools/1.jpg',
            link: '/programs/graduate',
        },
        {
            title: 'Post-Graduate Students',
            image: 'assets/img/schools/2.jpg',
            link: '/programs/post-graduate',
        },
        {
            title: 'Doctoral Students',
            image: 'assets/img/schools/3.jpg',
            link: '/programs/doctoral',
        },
        {
            title: 'Diploma Students',
            image: 'assets/img/schools/4.jpg',
            link: '/programs/diploma',
        },
        {
            title: 'Short-Term Students',
            image: 'assets/img/schools/5.jpg',
            link: '/programs/certificate',
        },
        {
            title: 'Integrated Program Students',
            image: 'assets/img/schools/6.jpg',
            link: '/programs/integrated',
        },
    ];
    index = 0;
    menuItems = [
        {
            label: 'Overview',
            icon: 'fas fa-eye', // FontAwesome
            color: 'bg-blue-500',
            description: 'Allied Health Sciences program at ARNI University...',
            highlights: [
                'Access to world-class infrastructure facilities',
                'Networking with industry leaders',
                'Continuous formative assessment',
                'Remedial sessions for students',
                'Collaboration with industry partners',
            ],
        },
        {
            label: 'Eligibility Criteria',
            icon: 'fas fa-check-circle',
            color: 'bg-green-500',
            description: 'Eligibility criteria for various programs...',
            highlights: ['Minimum qualification requirements', 'Age restrictions', 'Additional requirements'],
        },
        {
            label: 'Scholarships',
            icon: 'fas fa-gift',
            color: 'bg-red-500',
            description: 'Various scholarships offered at ARNI University...',
            highlights: ['Merit-based scholarships', 'Need-based financial aid', 'Special category scholarships'],
        },
        {
            label: 'Financial Assistance',
            icon: 'fas fa-rupee-sign',
            color: 'bg-orange-500',
            description: 'Financial assistance options available...',
            highlights: ['Education loans', 'Government aid', 'University grants'],
        },
        {
            label: "FAQ's",
            icon: 'fas fa-question-circle',
            color: 'bg-pink-500',
            description: 'Frequently asked questions and answers...',
            highlights: ['Application process', 'Program details', 'Fees and payment'],
        },
    ];
    programs = ['Allied Health Sciences', 'Engineering', 'Business Management', 'Law', 'Medical Sciences'];
    selectedItem = this.menuItems[0];
    activeTab: 'academic' | 'campus' = 'academic';
    currentIndex: number = 0;
    currentIndex1: number = 0;
    currentIndex2: number = 0;
    videos: SafeResourceUrl[] = [];

    constructor(private sanitizer: DomSanitizer,
                private location: Location) {
        this.currentPath = this.location.path();
        const videoUrls = [
            'https://youtu.be/RSa3v7KV2h4?si=ptiIHvt_ca5UvnaZ',
            'https://youtu.be/o2XShZHciAo?si=R4tZ9PMotrRhSDVJ',
            'https://youtu.be/plHHHDnscCA?si=cug6UsVHvRbcLGFl'
        ];

        this.videos = videoUrls.map(url => this.sanitizeVideo(this.convertToEmbedUrl(url)));
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

    sanitizeVideo(url: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    convertToEmbedUrl(youtubeUrl: string): string {
        return youtubeUrl.replace('youtu.be/', 'www.youtube.com/embed/').split('?')[0];
    }

    prevSlide() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
    }

    nextSlide() {
        if (this.currentIndex < this.getMaxIndex()) {
            this.currentIndex++;
        }
    }

    prevVideoSlide() {
        if (this.currentIndex1 > 0) {
            this.currentIndex1--;
        }
    }

    nextRecruitSlide() {
        if (this.currentIndex2 < this.getMaxIndex()) {
            this.currentIndex2++;
        }
    }

    prevRecruitSlide() {
        if (this.currentIndex2 > 0) {
            this.currentIndex2--;
        }
    }

    nextVideoSlide() {
        if (this.currentIndex1 < this.getMaxIndex()) {
            this.currentIndex1++;
        }
    }

    downloadBrochure() {
        alert('Downloading Brochure...');
    }

    getMaxIndex() {
        return Math.max(0, this.facilities[this.activeTab].length - 3);
    }
 /* constructor() { }
*/
  ngOnInit(): void {
  }

}
